function normalizeBaseUrl(url) {
  if (!url) return '';
  return String(url).replace(/\/$/, '');
}

// Server config for network/mobile access
const SERVER_IP = import.meta.env.VITE_SERVER_IP || '192.168.12.75';
const SERVER_PORT = Number(import.meta.env.VITE_SERVER_PORT || 3001);

// Use dynamic hostname for web dev, fixed IP for Capacitor/APK
const getApiHost = () => {
    // Check if running in Capacitor (Android/iOS app)
    if (window.Capacitor?.isNativePlatform?.()) {
        return SERVER_IP;
    }
    // Check if accessing from localhost (dev mode)
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return 'localhost';
    }
    // Otherwise use the current hostname (for LAN access)
    return window.location.hostname;
};

const envBaseUrl = normalizeBaseUrl(
  import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_API_URL
);

const vercelFallback =
  typeof window !== 'undefined' && window.location.hostname.endsWith('vercel.app')
    ? 'https://apps.quantrolix.ai/api/fire-pos'
    : '';

export const API_BASE_URL =
  envBaseUrl || vercelFallback || `http://${getApiHost()}:${SERVER_PORT}`;

export const SERVER_CONFIG = { ip: SERVER_IP, port: SERVER_PORT };

// ─── Native (Apple) build detection ──────────────────────────────────────────
// Apple App Store builds (Mac App Store via Electron, iOS via the WKWebView
// wrapper or Capacitor) may not sell digital subscriptions outside Apple's IAP
// (App Store Guideline 3.1.1). In these builds the app ships fully functional &
// free: no paywall, no upgrade CTAs, no external Stripe checkout. Browser users
// (no native marker) keep the Stripe subscription flow unchanged.
const isElectron =
  import.meta.env.MODE === 'electron' ||
  (typeof window !== 'undefined' && window.location.protocol === 'file:');
const isCapacitor =
  import.meta.env.MODE === 'capacitor' ||
  (typeof window !== 'undefined' && !!window.Capacitor?.isNativePlatform?.());
// The iOS App Store build is a native WKWebView wrapper that loads the live web
// app over https; it tags its User-Agent with "QuantrolixNative" so the same web
// bundle can detect it (it is NOT electron/capacitor and uses the normal origin).
const isIosWrapper =
  typeof navigator !== 'undefined' && /QuantrolixNative/i.test(navigator.userAgent || '');
const isNativeApp = isElectron || isCapacitor || isIosWrapper;

export { isElectron, isCapacitor, isIosWrapper, isNativeApp };
